__turbopack_context__.v({
  "arrow": "style-module-scss-module__u7cduq__arrow",
  "arrow-button-container": "style-module-scss-module__u7cduq__arrow-button-container",
  "arrow-container": "style-module-scss-module__u7cduq__arrow-container",
  "button-link": "style-module-scss-module__u7cduq__button-link",
  "component": "style-module-scss-module__u7cduq__component",
  "progress-circle": "style-module-scss-module__u7cduq__progress-circle",
  "slide": "style-module-scss-module__u7cduq__slide",
  "slide-active": "style-module-scss-module__u7cduq__slide-active",
  "slide-container": "style-module-scss-module__u7cduq__slide-container",
  "slide-content": "style-module-scss-module__u7cduq__slide-content",
  "slide-image-container": "style-module-scss-module__u7cduq__slide-image-container",
  "slide-overlay": "style-module-scss-module__u7cduq__slide-overlay",
  "slide-overlay-info": "style-module-scss-module__u7cduq__slide-overlay-info",
  "slide-transitioning": "style-module-scss-module__u7cduq__slide-transitioning",
  "top": "style-module-scss-module__u7cduq__top",
  "up-arrow": "style-module-scss-module__u7cduq__up-arrow",
});
